import { isEmpty } from 'lodash'
import * as MuiIcons from '@mui/icons-material'
import moment from 'moment'
import { capitalCase } from 'text-case'
import type { ErrorFetchProps, ErrorProps } from './types'
import CONSTANT from './constant'
class GLOBAL {
  static returnExceptionMessage = (
    _: boolean,
    value: ErrorProps | ErrorFetchProps | Response,
    success?: string
  ) => {
    const error = value as ErrorProps
    const errorFetch = value as ErrorFetchProps

    if (value) {
      const message = 'data' in value && error.data ? error.data.Message : errorFetch.message
      return this.splitExceptionMessage(message)
    }

    return success ?? 'Sukses'
  }

  static splitExceptionMessage = (value: string) => value && value.split('|')[0]

  static icon = (name: string) => MuiIcons[name as keyof typeof MuiIcons]

  static phoneNumberRegex = () =>
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

  static passwordRegex = () => /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/g

  static isFilterContainValue = (filter: object) => Object.values(filter).some((e) => !isEmpty(e))

  static encodeUrl = (value: string) => value.replaceAll(' ', '_')
  static decodeUrl = (value: string) => value.replaceAll('_', ' ')

  static emptyQuill = (value: string) => (value == '<p><br></p>' ? null : value)

  static tableTotalPage = (totalPage: number) =>
    Math.ceil(totalPage / CONSTANT.DEFAULT_PAGINATION_PER_PAGE)

  static tableNumber = (start: number) =>
    Array.from(Array(CONSTANT.DEFAULT_PAGINATION_PER_PAGE * (start + 1)).keys()).slice(
      -CONSTANT.DEFAULT_PAGINATION_PER_PAGE
    )

  static formatDate = (value: string) => (value ? moment(value).format('YYYY-MM-DD') : '-')

  static formatDateWithTime = (value: string) =>
    value ? moment(value).format('YYYY-MM-DD HH:mm') : '-'

  static formatDateWithTimeSecond = (value: string | null) => {
    if (value === '-') {
      return '-'
    }
    return value ? moment(value).format('DD MMM YYYY HH:mm:ss') : '-'
  }

  static formatDateddMMYYLongDateDetail = (value: string) =>
    value ? moment(value).format('DD MMM YYYY') : '-'

  static formatDateddMMYY = (value: string) => (value ? moment(value).format('DD-MM-YYYY') : '-')

  static formatDateddMMYYLongDate = (value: string) =>
    value ? moment(value).format('DD MMMM YYYY') : '-'

  static logout = async (callback: CallableFunction) => {
    localStorage.clear()
    return callback()
  }

  static formatCurrency = (value: number) =>
    value ? value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : '-'

  static numberFormat = (value: string | number) => {
    const parsed = parseFloat(value as string)
    const numeric = !isNaN(parsed)

    if (!numeric) return value
    return new Intl.NumberFormat(['ban', 'id']).format(parsed)
  }

  static timeConvert = (n: number) => {
    const num = n
    const hours = num / 60
    const rhours = Math.floor(hours)
    const minutes = (hours - rhours) * 60
    const rminutes = Math.round(minutes)
    return rhours + 'h ' + rminutes + 'm'
  }

  static capitalize = (value: string) => {
    const array = value.split(' ')
    const result = array.map((el) => el.charAt(0).toUpperCase() + el.slice(1))
    return result.join(' ')
  }

  // static base64ToBytes = (base64: string) => {
  //   const binString = atob(base64)
  //   return Uint8Array.from(binString, (m) => m.codePointAt(0))
  // }

  static bytesToBase64 = (bytes: Uint8Array) => {
    const binString = String.fromCodePoint(...bytes)
    return btoa(binString)
  }

  static humanizeKeys(obj: object): object {
    if (Array.isArray(obj)) {
      return obj.map(this.humanizeKeys)
    } else if (typeof obj === 'object' && obj !== null) {
      return Object.fromEntries(
        Object.entries(obj).map(([k, v]) => [capitalCase(k), GLOBAL.humanizeKeys(v)])
      )
    }
    return obj
  }

  static deepParseJSON(value: string) {
    try {
      // Try parsing the value
      const parsed = JSON.parse(value)

      // If it's an object or array, walk through recursively
      if (typeof parsed === 'object' && parsed !== null) {
        for (const key in parsed) {
          parsed[key] = this.deepParseJSON(parsed[key])
        }
      }
      return parsed
    } catch {
      // If it's not valid JSON, just return the value
      return value
    }
  }
  static generateColorFromLabel(label: string): string {
    let hash = 0
    for (let i = 0; i < label.length; i++) {
      const char = label.charCodeAt(i)
      hash = (hash << 5) - hash + char
      hash = hash & hash // Convert to 32-bit integer
    }
    const hue = Math.abs(hash) % 360
    return `hsl(${hue}, 70%, 60%)`
  }
}

export default GLOBAL
